import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { SliderModel } from '../models/slider.model';

@Injectable({
  providedIn: 'root',
})
export class SliderService {
  sliderList: Array<SliderModel> = [];

  constructor(
    private storage: AngularFireStorage,
    private firestore: AngularFirestore
  ) {}

  createSlider(slider: SliderModel) {
    return this.firestore.collection('/sliders').add(slider);
  }

  updateSlider(sliderId, slider: SliderModel) {
    return this.firestore.collection('/sliders').doc(sliderId).update(slider);
  }

  deleteSlider(id) {
    this.firestore.collection('/sliders').doc(id).delete();
  }

  getSliders() {
    return this.firestore
      .collection('/sliders', (ref) => ref.orderBy('position', 'asc'))
      .snapshotChanges();
  }

  getSliderById(sliderId) {
    return this.firestore
      .collection('/sliders')
      .doc(sliderId)
      .snapshotChanges();
  }

  uploadImage(nombreArchivo: string, datos: any) {
    return this.storage.upload(`sliders/${nombreArchivo}`, datos);
  }

  refImg(nombreArchivo: string) {
    return this.storage.ref(`sliders/${nombreArchivo}`);
  }
}
